import { SvelteFacet } from "../filter/SvelteFacet";
import { isSelected, SvelteFacetValue } from "../filter/SvelteFacetValue";
import { events } from "../events";
import { addCategoryPathToStore, deleteCategoryPathFromStore, emptyCategoryPathStore } from "./categoryPathStore";

const CATEGORY_PATH_FACET_NAME = "kategorien";
const FACET_VALUE_CLASS = "hc_facetValueInput";

export function syncRefinementBarCategoryPath(refinementBarValues: SvelteFacetValue[]) {
  const categoryPathFacetSelectedValues = SvelteFacet.facetName(CATEGORY_PATH_FACET_NAME)?.selectedValues;
  const categoryPathRefinementBarValues = refinementBarValues.filter(
    (value) => value.name === CATEGORY_PATH_FACET_NAME,
  );
  if (categoryPathFacetSelectedValues && categoryPathRefinementBarValues) {
    const selectedTemplate = categoryPathRefinementBarValues.find((value) => value.checked);
    if (selectedTemplate) {
      const parentNode = selectedTemplate.liElem?.parentNode;
      if (parentNode) {
        categoryPathFacetSelectedValues.forEach((value) => {
          removeValueWithRef(categoryPathRefinementBarValues, value.id);
          const cloned = selectedTemplate.cloneWithData(value.id, value.spanInnerHTML);
          const firstSibling = selectedTemplate.liElem?.nextSibling;
          if (cloned.liElem) {
            parentNode.insertBefore(cloned.liElem, firstSibling);
          }
        });
      }
    }
  }
}

function removeValueWithRef(values: SvelteFacetValue[], ref: string): void {
  const value = values.find((value) => value.ref === ref);
  value?.liElem?.remove();
}

function syncCategoryPathStore() {
  const categoryPathFacet = SvelteFacet.facetName(CATEGORY_PATH_FACET_NAME);
  if (categoryPathFacet) {
    emptyCategoryPathStore();
    categoryPathFacet.values.filter(isSelected).forEach((value) => addCategoryPathToStore(value));
  }
}

function addCategoryPathChangeListener() {
  const categoryPathFacet = SvelteFacet.facetName(CATEGORY_PATH_FACET_NAME);
  if (categoryPathFacet) {
    categoryPathFacet.facet.addEventListener("change", (e) => {
      if (e.target instanceof HTMLElement && e.target.classList.contains(FACET_VALUE_CLASS)) {
        const targetValue = SvelteFacetValue.factory.declare(e.target);
        if (targetValue) {
          if (targetValue.checked) {
            addCategoryPathToStore(targetValue);
          } else {
            deleteCategoryPathFromStore(targetValue.id);
          }
        }
      }
    });
  }
}

export function registerCategoryPathValuesSelection() {
  events.onFilterSectionLoaded(syncCategoryPathStore);
  events.onFilterSectionLoaded(addCategoryPathChangeListener);
}
